import { Component } from "@angular/core"
import { NavParams, ViewController, NavController, ActionSheetController } from "ionic-angular"

import { ProfilePage } from "../profile"

@Component({
  selector: "event-detail-page",
  templateUrl: "detail.html",
})
export class EventDetailPage {

  event: any = {}

  constructor(
    private navParams: NavParams,
    private viewCtrl: ViewController,
    private navCtrl: NavController,
    private actionSheetCtrl: ActionSheetController
  ) {

    this.event = this.navParams.get("event")
  }

  onExit() {

    this.viewCtrl.dismiss()
  }

  onShowOwner() {

    this.navCtrl.push(ProfilePage)
  }

  onConfirm() {

    this.viewCtrl.dismiss()
  }

  onExchange() {

    this.actionSheetCtrl.create({
      title: "Com quem você deseja trocar esse evento ?",
      buttons: [
        {
          text: "Qualquer pessoa",
          role: "destructive",
          handler: () => {

            console.log("anybody ...")
          },
        },
        {
          text: "Pedro Henrique",
        },
        {
          text: "Raquel Andrade Freitas",
        },
        {
          text: "Rodrigo dos Santos",
        },
        {
          text: "Urbano da Silva",
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    }).present()
  }
}



// WEBPACK FOOTER //
// ./src/pages/events/detail.ts